import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../service/cart.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {

  _allChecked = false;  //checkbox框选中问题
  _disabledButton = true;
  _checkedNumber = 0;
  _displayData: Array<any> = [];
  _operating = false;
  _deleting = false;
  _cartList = [];
  _cartList1 = [];
  _indeterminate = false;
  data: any[] = [];


  _current = 1;    //分页数据
  _pageSize = 10;
  _total = 1;
  _loading = true;


  public imgUrl;


  public isVisible: boolean = false;  //删除框数据
  public isConfirmLoading: boolean;

  constructor(
    private router: Router,
    private cartService:CartService
  ) {
  }

  ngOnInit() {

    //获取所有购物车内容
    this.updateOrder();
  }



  /**
   *  删除或者修改的时候更新cart
   */

  updateOrder() {
    this.cartService.getAllCart(this._current, this._pageSize).subscribe(cartList => {
      this._cartList = cartList["data"];
      this._total = cartList["recordsTotal"];
      this._displayData = this._cartList
      this._loading = false;
    })
  }

  refreshData() {
    this.updateOrder();
  }



  /**
   * 提交订单
   */
  _operateData() {
    var j = 0;
    for (var i = 0; i < this._displayData.length; i++) {
      if (this._displayData[i].checked) {
        this.data[j] = this._displayData[i].id;
        j = j + 1;
      }


    }


    this.cartService.addOrder(this.data).subscribe(res => {
      
      if (res["Message"] == "success") {
        this._operating = true;
        setTimeout(_ => {
          this._cartList.forEach(value => value.checked = false);
          this._refreshStatus();
          this._operating = false;
        }, 1000);
        this.router.navigateByUrl("cart/download");
      } else {
        alert("订单数据已存在");
      }

      


    })


  }


  /**
 * 删除订单
 */
  _delete() {
    this.isConfirmLoading = true;
    var j = 0;
    for (var i = 0; i < this._displayData.length; i++) {
      if (this._displayData[i].checked) {
        this.data[j] = this._displayData[i].dataid;
        j = j + 1;
      }


    }
    this.cartService.deleteCart(this.data).subscribe(res => {
      if (res["Message"] == "success") {
        this.updateOrder();
      } else {
        alert("删除失败");
      }

    })

    this._deleting = true;
    setTimeout(_ => {
      this._cartList.forEach(value => value.checked = false);
      this._refreshStatus();
      this._deleting = false;
    }, 1000);

    setTimeout(() => {
      this.isVisible = false;
      this.isConfirmLoading = false;
    }, 500);
  }



  /**
   * 删除确认框
   */
  _showModal = () => {
    this.isVisible = true;
  };



  handleOk = (e) => {
    this.isConfirmLoading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isConfirmLoading = false;
      this._delete();

    }, 300);
  };

  handleCancel = (e) => {
    this.isVisible = false;
  };





  _refreshStatus() {

    const allChecked = this._displayData.every(value => value.checked === true);
    const allUnChecked = this._displayData.every(value => !value.checked);
    this._allChecked = allChecked;
    this._indeterminate = (!allChecked) && (!allUnChecked);
    this._disabledButton = !this._cartList.some(value => value.checked);
    this._checkedNumber = this._cartList.filter(value => value.checked).length;
  }

  /**
   * 选择所有的数据
   * @param value 
   */
  _checkAll(value) {
    if (value) {
      this._displayData.forEach(data => data.checked = true);
    } else {
      this._displayData.forEach(data => data.checked = false);
    }
    this._refreshStatus();
  }


}
